import { post ,get} from './ApiService';
import { axiosAuthInstance } from '../configs/AxiosInstance';

const profileApiInstance = axiosAuthInstance;

// 1. User Login
export const userLogin = async (payload) => {
  // payload: { company_name = "flexcellence", application_name="flexboard", app_version_id, event_type_id, signin_mode_id, login_input, phone_ext_id, phone, password, google_id_token }
  try {
    const response = await post('/user-login', payload, { instance: axiosAuthInstance });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.detail || "Login failed. Please try again."
    };
  }
};

// 2. Register User
export const registerUser = async (payload) => {
  /**  payload:payload - {company_name = "flexcellence", application_name="flexboard", event_type_id, signin_mode_id, welldhan_login_type_id,
                        app_version_id, tos_id, first_name, last_name, email, phone_ext_id, phone,
                        username, gender_id, date_of_birth, password, confirmPassword, google_id_token} */
  try {
    const response = await post('/register-user', payload, { instance: axiosAuthInstance });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.detail || "Registration failed. Please try again."
    };
  }
};

// 3. Forgot Password (Send OTP)
export const forgotPasswordOtp = async (payload) => {
  // payload: { company_name = "flexcellence", application_name="flexboard", app_version_id, event_type_id, signin_mode_id, login_input, phone_ext, phone }
  try {
    const response = await post('/forgot-password-otp', payload, { instance: axiosAuthInstance });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.detail || "Failed to send OTP. Please try again."
    };
  }
};

// 4. Verify OTP
export const verifyOtp = async (payload) => {
  // payload: { otp, event_type_id }
  try {
    const response = await post('/verify-otp', payload, { instance: axiosAuthInstance });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.detail || "OTP verification failed. Please try again."
    };
  }
};

// 5. Resend OTP
export const resendOtp = async (payload) => {
  // payload: { event_type_id }
  try {
    const response = await post('/resend-otp', payload, { instance: axiosAuthInstance });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.detail || "Failed to resend OTP. Please try again."
    };
  }
};

// 6. Update Password
export const updatePassword = async (payload) => {
  // payload: { password, confirmPassword, event_type_id }
  try {
    const response = await post('/update-password', payload, { instance: axiosAuthInstance });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.detail || "Failed to update password. Please try again."
    };
  }
};

// 7. Modify User Profile
// payload as per schema shared (see below for example usage)
export const modifyUserProfile = async (payload) => {
  try {
    const response = await post('/modify-user-profile', payload, { instance: profileApiInstance });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.detail || "Failed to modify profile. Please try again."
    };
  }
};

// 8. Upload user files (profile photo, certificates, feed)
export const uploadUserFile = async ({ file, category, subcategory = null }) => {
  if (!file || !category) {
    return { success: false, message: "File and category are required." };
  }

  if (category === "feed" && !subcategory) {
    return {
      success: false,
      message: "Subcategory is required for feed uploads (e.g., diet, workout).",
    };
  }

  try {
    const formData = new FormData();
    formData.append("file", file);

    const params = {
      category,
      ...(subcategory ? { subcategory } : {}),
    };

    const token = localStorage.getItem("access_token");
    if (!token) {
      return {
        success: false,
        message: "Not authenticated. Please log in again.",
      };
    }

    const response = await axiosAuthInstance.post("/upload", formData, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        // Allow browser to set multipart boundary automatically
      },
    });

    return { success: true, data: response.data };
  } catch (error) {
    const status = error?.response?.status;
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      (status === 401
        ? "Session expired. Please log in again and retry the upload."
        : "Upload failed. Please try again.");

    return { success: false, message };
  }
};

/*
  Example payload for modifyUserProfile:

  {
    event_type_id: "your-event-type-id",

    profile: {
      operation: "ADD", // or "UPDATE", "DELETE"
      first_name: "FirstName",
      last_name: "LastName",
      date_of_birth: "YYYY-MM-DDTHH:mm:ss.sssZ",
      gender_id: "gender-id"
    },

    usernames: [
      {
        operation: "ADD",
        id: "username-id",
        username: "yourUsername"
      }
    ],

    emails: [
      {
        operation: "ADD",
        id: "email-id",
        email: "user@example.com"
      }
    ],

    phones: [
      {
        operation: "ADD",
        id: "phone-id",
        phone_extension_id: "phone-ext-id",
        phone_number: "1234567890"
      }
    ],

    locations: [
      {
        operation: "ADD",
        id: "location-id",
        location_id: "location-id",
        location_description: "Your location"
      }
    ],

    medical_histories: [
      {
        operation: "ADD",
        id: "medical-history-id",
        medical_history_id: "medical-history-id"
      }
    ],

    dietary_preferences: [
      {
        operation: "ADD",
        id: "dietary-pref-id",
        dietary_preference_id: "dietary-pref-id"
      }
    ],

    fitness_goals: [
      {
        operation: "ADD",
        id: "fitness-goal-id",
        fitness_goal_id: "fitness-goal-id"
      }
    ],

    weights: [
      {
        operation: "ADD",
        id: "weight-id",
        weight_unit_id: "weight-unit-id",
        weight: 70 // (number)
      }
    ],

    heights: [
      {
        operation: "ADD",
        id: "height-id",
        height_unit_id: "height-unit-id",
        height: 170 // (number)
      }
    ],

    physical_injuries: [
      {
        operation: "ADD",
        id: "injury-id",
        physical_injury_id: "injury-id"
      }
    ],

    activity_levels: [
      {
        operation: "ADD",
        id: "activity-level-id",
        activity_type_id: "activity-type-id"
      }
    ]
  }

  // Note: Only include the sections you want to update or add.
  // "operation" can be "ADD", "UPDATE", or "DELETE" as per requirement.
  // IDs for gender, dietary_preference, etc. come from profileUtils.
*/


// 9. Get User Profile Details
// Requires event_type_id as param (string, UUID),client_id is user id ;if not provide defaults to login user details
export const getUserProfileDetails = async (event_type_id, client_id = null) => {
  try {
    let url = `/get-user-profile-details?event_type_id=${event_type_id}`;
    if (client_id) {
      url += `&client_id=${client_id}`;
    }
    const response = await get(url, { instance: profileApiInstance });
    return { success: true, data: response };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.detail || "Failed to fetch profile details. Please try again.",
    };
  }
};

// 10. Bulk User Details (names) by user ids
// Accepts 1-100 ids per call (server 422s above 100); duplicates are deduped
// server-side; unknown/malformed ids come back in data.missing_ids rather
// than failing the batch. No event_type_id needed.
/**
 * @param {Array<string|number>} userIds
 * @returns {Promise<{success: true, data: { success: boolean, data: { users: Array<{ user_id: string, first_name: string, last_name: string }>, missing_ids: string[] }, error: string|null }} | {success: false, message: string}>}
 */
export const getBulkUserDetails = async (userIds) => {
  try {
    const payload = { user_ids: (userIds || []).map(String) };
    const response = await post('/users/bulk-details', payload, { instance: profileApiInstance });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.detail || "Failed to fetch user details. Please try again.",
    };
  }
};
